// ./rejectIcon.tsx
const RejectIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon
      points="16.879 9.242 14.758 7.121 12 9.879 9.242 7.121 7.121 9.242 9.879 12 7.121 14.758 9.242 16.879 12 14.121 14.758 16.879 16.879 14.758 14.121 12 16.879 9.242"
      fill="currentColor"
    />
    <path
      d="M12 24A12 12 0 1 1 24 12 12.013 12.013 0 0 1 12 24ZM12 3a9 9 0 1 0 9 9A9.01 9.01 0 0 0 12 3Z"
      fill="currentColor"
    />
  </svg>
);

export default RejectIcon;
